(() => {
  const dialog = document.querySelector('[data-policy-contact-dialog]');

  if (!dialog || typeof dialog.showModal !== 'function') return;

  const openDialog = () => {
    if (!dialog.open) dialog.showModal();
    const status = dialog.querySelector('[data-policy-contact-status]');
    const firstField = dialog.querySelector('input:not([type="hidden"]), select, textarea');
    (status || firstField)?.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.policy-email-trigger');
    if (!trigger) return;
    event.preventDefault();
    openDialog();
  });

  dialog.querySelectorAll('[data-policy-contact-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  if (dialog.hasAttribute('data-open-on-load')) openDialog();
})();
